import { Localization } from "../../../../OW.Remoting/Remoting/Localization";
import { registerCustomElement } from "../../../UI.ElementarControls/Utils/CustomElementUtils";
import { EmptyDataGridMessage } from "./EmptyDatagridMessage";
import { EmptyDatagridMessageType } from "./IEmptyDataGridMessage";
/**
* Slouží ke zobrazení vlastního textu pro prázdný pravý seznam
*/
export class TwoListEmptyDataGridMessage extends EmptyDataGridMessage {
    /**
     * Nastaví odpovídající hlášku u prázdného DataGridu
     * @param messageType Typ hlášky
     */
    protected override async _setMessageType(messageType: EmptyDatagridMessageType): Promise<void> {
        if (messageType === EmptyDatagridMessageType.initialEmpty) {
            this._resetIconState();

            if (this.emptyMessageCustomization.noItemsIcon) {
                this._iconElement.classList.add(this.emptyMessageCustomization.noItemsIcon);
            }
            Localization.addLocData(this._descElement, this.emptyMessageCustomization.noItemsLocKey || "GUI-646227"); // Sem přetáhněte položky

            return;
        }

        await super._setMessageType(messageType);
    }
}

registerCustomElement("tsc-TwoListEmptyDataGridMessage", TwoListEmptyDataGridMessage);
